export default function MapAndBrokerFallback() {
  return (
    <div className="mx-auto max-w-7xl my-6 lg:my-16 px-3 lg:px-4 xxl:px-10">
      <div className="gap-4 flex-col mdplus:flex-row xxl:gap-4 flex">
        <div className="rounded-md w-full lg:w-1/2 h-[517px] lg:h-[368px] mdplus:h-[21rem] xxl:h-[23rem] bg-grey50 animate-pulse"></div>
        <div
          id="map"
          className="rounded-md w-full lg:w-1/2 h-[320px] lg:h-[23rem] bg-grey50 animate-pulse"
        ></div>
      </div>
    </div>
  );
}
